import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const FIXED_DEPOSIT_REQUESTS_URL = `${API_URL}/fixed-deposit-requests`

export const service = {
  getFixedDepositRequests: (params: ParamsModel) => {
    return axios.get(FIXED_DEPOSIT_REQUESTS_URL, {params})
  },
  getFixedDepositRequestDetail: (id: number) => {
    return axios.get(`${FIXED_DEPOSIT_REQUESTS_URL}/${id}`)
  },
  exportFixedDepositRequests: (params: ParamsModel) => {
    return axios.get(`${FIXED_DEPOSIT_REQUESTS_URL}/export`, {params, responseType: 'blob'})
  },
}
